import { Env, readFromEnv } from '@cinch-nx/environments'
import axios from 'axios'
import { convertSearchFiltersToQueryParams } from '../../utils'
import { useState } from 'react'
import { useUsedCarsData } from '../use-used-cars-data/use-used-cars-data'

export type SearchAlertRequestBody = {
  sa_email_address: string
  sa_url: string
  sa_frequency: '1d' | '7d'
}

type RequestStatus = 'initial' | 'pending' | 'error' | 'success'

export const httpClient = axios.create()

export function useSearchAlerts() {
  const { searchParams } = useUsedCarsData()
  const searchApiUrl = readFromEnv(Env.SearchServiceUrl)
  const queryParams = convertSearchFiltersToQueryParams(searchParams)
  const [fetchStatus, setFetchStatus] = useState<RequestStatus>('initial')
  const [error, setError] = useState<unknown>(null)
  const url = `${searchApiUrl}/alert`

  const registerSearchAlert = async (email: string, frequency: string) => {
    if (!email || !frequency) {
      return
    }

    setError(null)
    setFetchStatus('pending')

    try {
      await httpClient.post<Record<string, never>>(
        url,
        {
          sa_email_address: email,
          sa_frequency: frequency,
          sa_url: `?${queryParams}`,
        },
        {
          headers: { 'x-search-api-consumer': 'search-used-cars' },
        },
      )
      setFetchStatus('success')
    } catch (error_) {
      setError(error_)
      setFetchStatus('error')
    }
  }

  return { registerSearchAlert, fetchStatus, error }
}
